import React from 'react'
import Interna from '../../modules/v1/interna'

export default props => <Interna {...props} />
